<template>
	<v-row
		:align="align"
		:justify="justify"
	>
		<v-col>
			<slot />
		</v-col>
	</v-row>
</template>
<script>

export default {
	name: "Page",
	components: {},
	props: {
		align: { type: String, default: "start" },
		justify: { type: String, default: "center" },
	},
	data () {
		return {};
	},
	computed: {},
	watch: {},
	created () {
	},
	mounted () {
	},
	updated () {
	},
	destroyed () {
	},
	methods: {},
};
</script>

<style scoped>

</style>
